module.exports = require('./lib/jwt');
